(() => {
  if (window.__cletteJudgeMeCarouselReady) return;
  window.__cletteJudgeMeCarouselReady = true;

  const ROOT_SELECTOR = '.template-product .jdgm-carousel-wrapper';
  const TRACK_SELECTOR = '.jdgm-carousel__item-container, .jdgm-carousel__item-wrapper';

  const initialise = (root) => {
    if (!root || root.dataset.cletteCarouselReady === 'true') return;
    const track = root.querySelector(TRACK_SELECTOR);
    if (!track) return;

    root.dataset.cletteCarouselReady = 'true';
    track.setAttribute('tabindex', '0');
    track.setAttribute('aria-label', 'Customer reviews');

    /* Judge.me may replace its arrow nodes after initial render. Delegate from
       the stable wrapper so the custom controls survive those DOM refreshes. */
    root.addEventListener('click', (event) => {
      const arrow = event.target.closest('.jdgm-carousel__left-arrow, .jdgm-carousel__right-arrow');
      if (!arrow || !root.contains(arrow)) return;

      const liveTrack = root.querySelector(TRACK_SELECTOR);
      if (!liveTrack) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      const card = liveTrack.querySelector('.jdgm-carousel-item');
      const distance = card ? card.getBoundingClientRect().width + 12 : liveTrack.clientWidth * 0.82;
      const direction = arrow.classList.contains('jdgm-carousel__left-arrow') ? -1 : 1;
      liveTrack.scrollBy({ left: direction * distance, behavior: 'smooth' });
    }, true);
  };

  const initialiseAll = () => document.querySelectorAll(ROOT_SELECTOR).forEach(initialise);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseAll, { once: true });
  } else {
    initialiseAll();
  }

  new MutationObserver(initialiseAll).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', initialiseAll);
})();
